import React from 'react';
import './MLOps.css';

const m_wywl = () => {
    const state = {
        wywl_item: [
            {
                text: `Experimentation to Production`,
            },
            {
                text: `Agile Data Science`,
            },
            {
                text: `Data Science Architecture`,
            },
            {
                text: `Runtime Pipelines`,
            },
            {
                text: `Model Monitoring & Auditing`,
            },
            {
                text: `Automated Machine Learning`,
            },
            {
                text: `Debugging Machine Mearning`,
            },
            {
                text: `Kubeflow and Kubernetes`,
            },
            {
                text: `Distributed Computing`,
            },
            {
                text: `Data Science Workflows`,
            },
            {
                text: `Data Provenance & Governance`,
            },
            {
                text: `and many more…`,
            },
      ],
    };

    const renderWYWL = (item, i) => {
        return (
            <div className="m_wywl_item">
                <p className="m_wywl_text inner_pages--text">{item.text}</p>
            </div>
        );
    };

    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">What You’ll Learn</h3>
                <p className="m_learning--text inner_pages--text">Data science has many focus areas.  The goal of this track is to accelerate your knowledge of data science through a series of introductory level training sessions, talks, tutorials and workshops on the most important data science tools and topics.</p>
                <div className="m_wywl_blocks">
                    {state.wywl_item.map((item, i) => renderWYWL(item, i))}
                </div>
            </div>
        </div>
    );
};

export default m_wywl;